import { useContext, useEffect, useState } from "react"
import FeatureTypeTreeItem from "./FeatureTypeTreeItem"
import { GetApi } from "../../../../api/api"
import { IFeatureTypeGroup } from "./FeatureTypeGroups"
import React from "react"
import { Spinner, TreeViewItem } from "@trimbleinc/modus-react-bootstrap"
import { FeatureCatalogContext } from "../../FeatureCatalogProvider"
import { FeatureType } from "../../../../api/types"
import { useHistory, useParams } from "react-router-dom"
import useQuery from "../UseQuery"

const featureTypesComponent = (props: { featureTypeGroup: IFeatureTypeGroup }) => {
  const [featureTypes, setFeatureTypes] = useState(new Array<FeatureType>())
  const [loaded, setLoaded] = useState(false)
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog } = useParams<{ catalog: string; type: string; pid: string }>()
  const language = useQuery().get("language")

  useEffect(() => {
    setLoaded(false)
    const result = GetApi()
      .then((api) => api.getAnyFeatureTypesByGroup(catalog, props.featureTypeGroup.pid!, language))
      .then((allFeatureTypes) =>
        allFeatureTypes.map((featureType) => {
          return featureType
        })
      )

    result.then((allFeatureTypes) => {
      setFeatureTypes(allFeatureTypes)
      setLoaded(true)
    })
  }, [language])

  if (!loaded) {
    return (
      <TreeViewItem
        nodeId={props.featureTypeGroup.pid}
        id="filenamenode"
        label={<Spinner animation="border" role="status" variant="primary" />}
        className="card-text-2"
      />
    )
  }

  return (
    <>
      {featureTypes.map((featureType) => {
        const onClick = () => {
          context.setAtId(null)
          context.setTypeDisplayName(featureType.name)
          context.updateHistory(history, catalog, "featureType", "" + featureType.id)
        }
        if (context.showAbstractFeatures || !featureType.isAbstract) {
          return (
            <FeatureTypeTreeItem
              featureType={featureType}
              key={"ft:" + props.featureTypeGroup.pid! + featureType.id}
              onClick={onClick}
            />
          )
        } else {
          return
        }
      })}
    </>
  )
}

export default featureTypesComponent
